<template>
  <!-- Bootstrap Alert -->
  <div
    v-if="visible"
    class="alert alert-dismissible d-flex align-items-center position-fixed top-0 end-0 m-3 shadow rounded-2 fade show"
    :class="alertVariant"
    role="alert"
    :aria-live="ariaLive"
    style="z-index: 1090"
  >
    <span class="me-3">{{ message }}</span>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      @click="close"
    ></button>
  </div>
</template>

<script setup>
/**
 * Bootstrap 5.3 Alert (JS 플러그인 불필요)
 * - window.bootstrap 미사용
 * - 번들 하나만(bootstrap.bundle 또는 ESM 부분 임포트) 사용 권장
 */
import { ref, computed } from "vue";

const props = defineProps({
  message: { type: String, required: true },
  // success | error → success | danger 로 매핑
  type: {
    type: String,
    default: "success",
    validator: (v) => ["success", "error"].includes(v),
  },
});

const emit = defineEmits(["close"]);
const visible = ref(true);

// Bootstrap 변형 클래스 계산
const alertVariant = computed(() =>
  props.type === "error" ? "alert-danger" : "alert-success"
);

// 접근성: 에러는 assertive, 그 외는 polite
const ariaLive = computed(() =>
  props.type === "error" ? "assertive" : "polite"
);

function close() {
  visible.value = false;
  emit("close");
}
</script>

<!-- 커스텀 CSS 불필요 (Bootstrap 유틸리티 사용) -->
<style scoped></style>
